import {
  SET_ORDERS,
  GET_ORDERS,
  SET_COOKS,
  GET_COOKS,
  ACCEPT_ORDER,
  RATE_GUEST,
  OrderProps,
  UserDetails,
  Ratings,
  GET_RATINGS,
  SET_RATINGS,
} from './types';

export const getOrders = () => ({ type: GET_ORDERS });

export const setOrders = (orders: OrderProps[]) => ({
  type: SET_ORDERS,
  orders,
});

export const getCooks = (userid: string) => ({ type: GET_COOKS, userid });

export const setCooks = (userinfo: UserDetails) => ({
  type: SET_COOKS,
  userinfo,
});

export const acceptOrRefuseOrder = (
  orderid: string,
  status: string,
  refusedmessage: string,
  guestid: string
) => ({
  type: ACCEPT_ORDER,
  orderid,
  status,
  refusedmessage,
  guestid,
});

export const rateGuest = (ratings: Ratings) => ({
  type: RATE_GUEST,
  ratings,
});

export const getRatings = () => ({ type: GET_RATINGS });

export const setRatings = (ratings: Ratings[]) => ({
  type: SET_RATINGS,
  ratings,
});
